module.exports = __webpack_public_path__ + "img/011-little-red-riding-hood.eb90aeb2.png";